import { useEffect, useMemo, useState } from 'react'

import { destinationOptions } from '../api'

export function useDestinations(country) {
  const [destinations, setDestinations] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    destinationOptions()
      .then((data) => {
        if (!cancelled) setDestinations(Array.isArray(data) ? data : [])
      })
      .catch(() => {
        if (!cancelled) setDestinations([])
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  const countryOptions = useMemo(
    () => destinations.map((dest) => ({ value: dest.country, label: dest.country })),
    [destinations],
  )

  const cityOptions = useMemo(() => {
    const cities = country
      ? destinations.find((dest) => dest.country === country)?.cities ?? []
      : [...new Set(destinations.flatMap((dest) => dest.cities))].sort((a, b) =>
          a.localeCompare(b, 'fr'),
        )
    return cities.map((city) => ({ value: city, label: city }))
  }, [destinations, country])

  return { countryOptions, cityOptions, loading }
}
